<template>
    <div :class="['tripActionInfoButtonDiv', upNext ? 'nextStep' : 'inactive']" @click="upNext ? setTripStatus() : {}">
        <div class="actionCheckBox">
            <i :class="[actionCompleted ? 'fa fa-check-square-o' : 'fa fa-square-o']"></i>
        </div>
        <div class="actionMessage">
            {{ tripAction.displayText }}
        </div> 
    </div>
    
</template>

<script>
    import epoch from 'epoch.js'

    export default {
        props: [
            'tripAction',
            'trip',
        ],
        computed: {
            upNext() {
                return (this.trip.transit_action_stage + 1) == this.tripAction.stage;
            },
            actionCompleted() {
                return this.trip.transit_action_stage >= this.tripAction.stage;
            },
        },
        methods: {
            setTripStatus() {
                let now = epoch().datetime();
                let tripStatusUpdate = {transit_action_stage: this.tripAction.stage, transit_action_time: now};

                if(this.tripAction.options) {
                    for(const option in this.tripAction.options) {
                        tripStatusUpdate[option] = this.tripAction.options[option];
                    }
                }

                this.$eventHub.$emit('updateTrip', this.trip.id, tripStatusUpdate);
            },
        }
    }
</script>

<style scoped>
    .tripActionInfoButtonDiv {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: flex-start;
        border-radius: 1vw;
        padding: 1.25vh 0;
        margin: .4vh 0;
    }

    .tripActionInfoButtonDiv.nextStep {
        background-color: #07fc03;
        border-top: solid thick #9efc9d;/*#75f573;*/
        border-left: solid thick #9efc9d;/*#479645;*/
        border-right: solid thick #049c02;
        border-bottom: solid thick #025201;
        font-style: normal;
        font-weight: bold;
    }

    .tripActionInfoButtonDiv.inactive {
        border: solid thin darkgray;
        font-style: italic;
        font-weight: normal;
    }

    .actionCheckBox {
        width: 20%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.75em;
    }

    .actionMessage {
        width: 60%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .initiateActionButton {
        font-weight: bold;
    }

    .actionDisabled {
        border-color: grey !important;
        font-style: italic;
        font-weight: normal;
    }

    .tripActionInfoButtonDiv.completedAction {
        flex-direction: row;
        justify-content: left;
        border: none;
        padding: 0
    }

    .tripActionTaken {
        margin: 0 1vw;
    }

    .actionActions {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    .actionActions.actionCompleted {
        justify-content: flex-start;
    }

    .tripActionTaken {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 15%;
    }

    .notDone {
        color: grey;
        font-weight: 50;
    }
</style>